import PropTypes from 'prop-types';

import PersonFormComponent from '../Person/PersonFormComponent';

import { formatSelect, required } from '../Forms/utils';

import { CHECKBOX, REACT_SELECT_INPUT } from '../Forms/fieldTypes';

const AdminUserFormComponent = (props) => {
  const {
    isMasterPM,
    isService,
    pmcs,
    buildings,
    hasSelectedPmcs,
    onSelectExisting,
    onLoad,
    onSubmit,
    formValues,
    formInitialValues,
    selectExisting,
    initialValues,
  } = props;

  const additionalFormData = [
    {
      keyName: 'isService',
      label: 'Call Center Agent',
      fieldType: CHECKBOX,
      validate: null,
      isHidden: isMasterPM,
    },
    {
      keyName: 'pmcs',
      label:
        'Property Management Company(ies) (Leave blank to create an admin)',
      fieldType: REACT_SELECT_INPUT,
      multi: true,
      options: formatSelect(pmcs),
      validate: isMasterPM ? [required] : [],
      isHidden: isService,
    },
    {
      keyName: 'buildings',
      label: 'Building(s)',
      fieldType: REACT_SELECT_INPUT,
      options: formatSelect(buildings),
      multi: true,
      validate: [],
      isHidden: isService || isMasterPM || !hasSelectedPmcs,
    },
  ];
  return (
    <PersonFormComponent
      title="Add Admin User"
      formValues={formValues}
      formInitialValues={formInitialValues}
      additionalFormData={additionalFormData}
      onSelectExisting={onSelectExisting}
      onLoad={onLoad}
      onSubmit={onSubmit}
      selectExisting={selectExisting}
      initialValues={initialValues}
    />
  );
};

AdminUserFormComponent.defaultProps = {
  isMasterPM: true,
  isService: true,
  hasSelectedPmcs: false,
  selectExisting: {},
};

AdminUserFormComponent.propTypes = {
  pmcs: PropTypes.instanceOf(Array).isRequired,
  buildings: PropTypes.instanceOf(Array).isRequired,
  onLoad: PropTypes.func.isRequired,
  onSelectExisting: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Object).isRequired,
  formInitialValues: PropTypes.instanceOf(Object).isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  isMasterPM: PropTypes.bool,
  isService: PropTypes.bool,
  hasSelectedPmcs: PropTypes.bool,
  selectExisting: PropTypes.instanceOf(Object),
};

export default AdminUserFormComponent;
